<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold text-red-400 my-5">{{ item.responsible }}</div>
            <a-table :dataSource="item.matters" :columns="filterColumns" :pagination="false" >
              <span slot="description" slot-scope="text,record">
                {{ limitTextTask(record.description) }}
              </span>
              <div slot="client" slot-scope="text,record">
                <template v-if="record.client.person">{{ record.client.person.first_name }} {{ record.client.person.last_name }}</template>
                <template v-else>{{ record.client.company.name }}</template>
              </div>
              <div slot="estimates" slot-scope="text,record">
                {{ record.estimates !== null ? record.estimates + 'h' : '-'}}
              </div>
            </a-table>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Responsible Lawyer">
              <a-radio-group v-decorator="['which_responsible',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeResponsible">
                <a-radio :style="radioStyle" :value="1">
                  All Responsible Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Responsible Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="responsible_value === 2"
              url="/account/list/"
              label="User"
              field="responsible"
              :required="false"
              method="get"
              placeholder="Find A User"
              mode="multiple"
              class="w-full self-end"
            />
          </div>
          <a-form-item>
            <a-checkbox-group
              v-decorator="['options',{ rules: [{ required: false, message: 'this field is required.' }] }]"
              :options="checkboxes"
              class="flex flex-col gap-y-4 select-none"
            />
          </a-form-item>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','MatterReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";
import _ from 'lodash'

const columns = [
  {
    title: 'Matter',
    dataIndex: 'title',
    key: '1',
  },
  {
    title: 'Client',
    dataIndex: 'client',
    key: '2',
    scopedSlots: { customRender: 'client' },
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: '3',
    scopedSlots: { customRender: 'description' },
  },
]

export default {
  name: "ComponentGeneral",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      responsible_value: null,
      title:'Matters by Responsible Lawyer',
      columns,
      filterColumns: [],
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
      checkboxes:[
        { label: 'Include completed tasks', value: 'include_task_complete' },
        { label: 'Include time estimates', value: 'include_estimate' },
      ]
    }
  },
  watch:{
    'result':{
      handler() {
        let cols           = []
        const taskEstimate = { title: 'Task complete',dataIndex: 'task_complete', key: '4' }
        const estimate     = { title: 'Estimates', dataIndex: 'estimates', key: '5', scopedSlots: { customRender: 'estimates' } }
        const list         = this.form.getFieldValue('options')
        if (list !== undefined) {
          list.includes('include_task_complete') ? cols.push(taskEstimate) : cols.filter(item => item !== taskEstimate)
          list.includes('include_estimate')      ? cols.push(estimate)     : cols.filter(item => item !== estimate)
        }
        const tblCols      = _.uniqBy([...this.columns,...cols], 'key')
        this.filterColumns = tblCols
      },
    },
  },
  methods:{
    handleChangeResponsible({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ responsible: [] })
      this.responsible_value = value
    },
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query                     = []
            values.options                  = values.options === undefined ? [] : values.options
            if (values.responsible && values.responsible.length)  query.push({ field:'responsible__id', condition: 'in', value: values.responsible, operation: 'and' })
            if (values.practice_area) query.push({ field:'practice_area', condition: '=', value: values.practice_area, operation: 'and' })
            const {data}                    = await axios.post('matter/report/matters',{
              group_by: 2 ,
              query : query.length ? query : undefined,
              options: values.options,
              responsible: values.responsible && values.responsible.length ? values.responsible : undefined
            })
            this.visibleRes                 = true
            this.result                     = Object.values(data)
          }catch (e) {
            this.visibleRes                 = false
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    }
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
